import type { GTM } from "../../../../legacy/services/gtmEvent/GTMInterfaces";
import { sendGTMEvent } from "../../../../legacy/services/gtmEvents";

export function trackChatbotPanelOpened(): void {
  const EVENT_NAME = "chatbot-panel-opened";

  const eventData: GTM.Event = {
    event: EVENT_NAME,
    url: window.location.href,
  };

  sendGTMEvent(eventData);
}
